import { BrandPreviewComponent } from "./components/brand-preview/brand-preview.component";
import { BrandsService } from "./services";

export const BRANDS_COMPONENTS = [
    BrandPreviewComponent
  ];
  
  export const BRANDS_SERVICES = [
      BrandsService
  ];
  